import React from "react";
import { GridSpinner } from "react-spinners-kit";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	spinnerBuffer: {
		marginTop: 15,
		marginBottom: 15,
	},
}));

const Spinner = () => {
	const classes = useStyles();

	return (
		<Grid container direction="column" justify="center" alignItems="center">
			<Grid item className={classes.spinnerBuffer}>
				<GridSpinner size={60} color="#757de8" />
			</Grid>
		</Grid>
	);
};

export default Spinner;
